import fc from '@/firebaseConfig'
import firebase from "firebase/app";
import moment from 'moment';
// import algoliasearch from "algoliasearch";

export default {
  namespaced: true,
  state: {
    list: [],
    page: 1,
    pageLimit: 10,
    loading: false,
    count: 0,
    keyword: "",
    emptyList: true,
    stackPage: [],
    currentPageAlgolia: 0,
    mDocDownloadListUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setList(state, val) {
      state.list = val
    },
    setStackPage(state, val) {
      state.stackPage = val
    },
    setEmptyList(state, val) {
      state.emptyList = val
    },
    setPage(state, val) {
      state.page = val
    },
    setKeyword(state, val) {
      state.keyword = val
    },
    setCurrentPageAlgolia(state, val) {
      state.currentPageAlgolia = val
    }
  },
  actions: {
    getList({commit}, {id, isNextPage}) {
      commit('setLoading', true)

      if (this.state.docsDownloadedByCompany.keyword) {
        // let client = algoliasearch("RD6OLUBOCH", "24a22f381826bcad0f255cfdfa7174f4");
        // let index = client.initIndex('Companies_' + id + '_DocsDownloaded');
        // if (isNextPage !== undefined) {
        //   let currentPageAlgoliaTmp = this.state.docsDownloadedByCompany.currentPageAlgolia
        //   if (isNextPage) {
        //     currentPageAlgoliaTmp += 1
        //   } else {
        //     currentPageAlgoliaTmp -= 1
        //   }
        //   commit('setCurrentPageAlgolia', currentPageAlgoliaTmp)
        // }
        //
        // // Perform an Algolia search:
        // // https://www.algolia.com/doc/api-reference/api-methods/search/
        // index.search(this.state.docsDownloadedByCompany.keyword, {
        //   page: this.state.docsDownloadedByCompany.currentPageAlgolia,
        //   hitsPerPage: this.state.docsDownloadedByCompany.pageLimit,
        // }).then(function (responses) {
        //   responses.hits.forEach((docsDownloaded) => {
        //     docsDownloaded.id = docsDownloaded.objectID
        //     docsDownloaded['timeCreated'] = new firebase.firestore.Timestamp(docsDownloaded['timeCreated']._seconds, docsDownloaded['timeCreated']._nanoseconds)
        //     docsDownloaded['timeCreated'] = moment(docsDownloaded['timeCreated'].toDate()).add(543, 'year').format("Do MMM YY[,] HH:mm [น.]")
        //   })
        //
        //   commit('setPage', responses.page + 1)
        //   commit('setEmptyList', responses.nbPages === 1)
        //   commit('setList', responses.hits)
        //
        // });
      } else {

        const downloaded = fc.companies.doc(id).collection("DocsDownloaded")

        let query = downloaded
        let isNext = true

        if (this.state.docsDownloadedByCompany.page > 1) {
          var lastVisible
          if (isNextPage) {
            lastVisible = this.state.docsDownloadedByCompany.list[this.state.docsDownloadedByCompany.list.length - 1].id
            query = query.orderBy(firebase.firestore.FieldPath.documentId()).startAfter(lastVisible).limit(this.state.docsDownloadedByCompany.pageLimit)
          } else {
            lastVisible = this.state.docsDownloadedByCompany.stackPage[this.state.docsDownloadedByCompany.page - 1]
            isNext = false
            query = query.orderBy(firebase.firestore.FieldPath.documentId()).startAt(lastVisible).limit(this.state.docsDownloadedByCompany.pageLimit)
          }

        } else if (this.state.docsDownloadedByCompany.pageLimit) {
          query = query.limit(this.state.docsDownloadedByCompany.pageLimit)
        }

        // if (keyword) {
        //   query = query.where('@Keywords', 'array-contains', keyword.toString())
        // }

        if (this.state.mDocDownloadListUnsubscribeObject) { this.state.mDocDownloadListUnsubscribeObject() }
        this.state.mDocDownloadListUnsubscribeObject = query.onSnapshot((docsDownloadedList) => {
          let downloadedList = []
          let countIndex = 1
          if (docsDownloadedList.size !== 0) {
            docsDownloadedList.forEach((docsDownloaded) => {
              let downloaded = docsDownloaded.data()
              downloaded.id = docsDownloaded.id
              moment.locale('th')
              downloaded.timeCreated = moment(downloaded.timeCreated.toDate()).add(543, 'year').format("Do MMM YY[,] HH:mm [น.]")
              downloadedList.push(downloaded)
              if (countIndex === 1 && isNext && !this.state.docsDownloadedByCompany.stackPage.some((e) => e === docsDownloaded.id)) {
                commit('setStackPage', [...this.state.docsDownloadedByCompany.stackPage, ...[docsDownloaded.id]])
              }
              countIndex++;

            });

            commit('setList', downloadedList)
            commit('setEmptyList', false)
          } else {
            commit('setEmptyList', true)
          }
        });
      }
      commit('setLoading', false)
    },
    getDocDownloadListUnsubscribe() {
      if (this.state.mDocDownloadListUnsubscribeObject) {
        this.state.mDocDownloadListUnsubscribeObject()
        this.state.mDocDownloadListUnsubscribeObject = null
      }
    },
    updatePage({commit}, {page}) {
      commit('setPage', page)
    },
    updateKeyword({commit}, {keyword}) {
      commit('setCurrentPageAlgolia', 0)
      commit('setKeyword', keyword)
    },
  },
}
